import mutations from './mutations';
import actions from './actions';
import Fare from "./interfaces/fare";
import getters from "./getters";

export interface FaresState {
    availableFares: Fare[]
}

export const FaresInitialState: FaresState = {
    availableFares: []
}

export default {
    namespaced: false,
    state: FaresInitialState,
    mutations,
    actions,
    getters
}
